// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".update-password>h3{margin:1rem}.update-password-container>label{float:left;width:150px;text-align:right;margin-top:0px;font-weight:bolder;margin-right:10px}.update-password-container>input{width:auto}.update-password-container #require{color:red;display:inline;padding-right:8px}.update-password-container>small{display:block;margin-left:160px;color:gray}.update-password-container>button{margin-top:1rem}", ""]);
// Exports
module.exports = exports;
